var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconmonstr-twitter-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-volunteer-campaign-page",
    transform: "translate(-1320.000000, -1835.000000)",
    fill: "#1DA2F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-icons",
    transform: "translate(1304.000000, 1787.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-twitter-4",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.373,0 0,5.373 0,12 C0,18.627 5.373,24 12,24 C18.627,24 24,18.627 24,12 C24,5.373 18.627,0 12,0 Z M18.066,9.645 C18.249,13.685 15.236,18.189 9.902,18.189 C8.28,18.189 6.771,17.713 5.5,16.898 C7.024,17.078 8.545,16.654 9.752,15.709 C8.496,15.686 7.435,14.855 7.068,13.714 C7.519,13.8 7.963,13.775 8.366,13.665 C6.985,13.387 6.031,12.143 6.062,10.812 C6.45,11.027 6.892,11.156 7.363,11.171 C6.084,10.316 5.722,8.627 6.474,7.336 C7.89,9.074 10.007,10.217 12.394,10.337 C11.975,8.541 13.338,6.81 15.193,6.81 C16.018,6.81 16.765,7.159 17.289,7.717 C17.943,7.589 18.559,7.349 19.113,7.02 C18.898,7.691 18.443,8.253 17.85,8.609 C18.431,8.539 18.985,8.385 19.499,8.156 C19.115,8.734 18.629,9.24 18.066,9.645 L18.066,9.645 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.b2749eb38d1b547b842ffe7ab4b3139e.svg";
export { ForwardRef as ReactComponent };